// src/hooks/useTopicsSimple.js
import { useEffect, useState } from "react";

import { fetchTopics } from "../../api/api";
import { useTopicsContext } from "../context/TopicsContext";

export const useTopics = (token) => {
  const { state: topics, dispatch } = useTopicsContext();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!token) return;
    setLoading(true);
    setError(null);

    if (topics.length > 0) {
      setLoading(false);
      return;
    }
    fetchTopics(token)
      .then((data) => {
        // Assuming data is an array of topics
        dispatch({ type: "SET_TOPICS", topics: data });
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching topics:", err);
        setError("Error fetching topics.");
        setLoading(false);
      });
  }, [token, dispatch]);

  return { topics, loading, error };
};
